// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"FavoriteNoResult-module__mainContainer","blueButtonDesign":"FavoriteNoResult-module__blueButtonDesign"};